/*
 * @Date: 2020-03-09 21:30:19
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-10 21:48:31
 * @FilePath: /rongxin.web/src/views/home/cooperative-partner/index.js
 */
import Service from './servece.js';
export default {
  name: 'cooperativePartner',
  data() {
    return {
      partnerArr: []
    };
  },
  created() {
    this.getPartnerList();
  },
  methods: {
    getPartnerList() {
      Service.getPartnerList({limit: 'unlimit', status: 1, source: 'guanWang'}).then(data => {
        this.partnerArr = data.data && data.data.result.slice(0, 12);
      });
    },
    // 二级页面
    goPartner() {
      this.$router.push({path: 'partnerDetail'});
    }
  }
};
